import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-welcome-message',
    standalone: true,
    imports: [TranslateModule, NgOptimizedImage],
    templateUrl: './welcome-message.component.html',
    styleUrls: ['./welcome-message.component.scss'],
})
export class WelcomeMessageComponent {
    readonly canCurrentUserUseSequencing = input.required<boolean>();
}
